import { Component, computed, input } from '@angular/core';
import { ECurrencyCode } from 'src/models/common.model';
import { EFeeType, IEntryFeeCalculationWithAllRatiosOut, PaymentType } from 'src/models/products.model';

@Component({
  selector: 'liberro-entry-fee-calc-tooltip-content',
  standalone: false,
  templateUrl: './entry-fee-calc-tooltip-content.component.html',
})
export class EntryFeeCalcTooltipContentComponent {
  public type = input.required<'REGULAR' | 'ONETIME'>();
  public displayFee = input.required<IEntryFeeCalculationWithAllRatiosOut>();
  public currencyCode = input.required<ECurrencyCode>();
  public oneTimeSpecificCode = input.required<string>();
  public regularSpecificCode = input.required<string>();

  public readonly EFeeType = EFeeType;

  public paymentTypeKeys = computed<PaymentType>(() => ({
    'REGULAR': {
      desc: 'regularPayments',
      explain: 'fee2_regular',
      paymentInfo: 'paymentInfo_regular',
      code: this.regularSpecificCode(),
    },
    'ONETIME': {
      desc: 'onetimePayments',
      explain: 'fee2_onetime',
      paymentInfo: 'paymentInfo_onetime',
      code: this.oneTimeSpecificCode(),
    }
  }));

  public feeRatio = computed(() => {
    return this.type() === 'REGULAR'
      ? this.displayFee().entryRegularRatio
      : this.displayFee().entryOneTimeRatio;
  });

  public feeVat = computed(() => {
    return this.type() === 'REGULAR'
      ? this.displayFee().entryRegularFeeVat
      : this.displayFee().entryOneTimeFeeVat;
  });

  public discountRegularDeposit = computed(() => {
    return this.displayFee().discountRegularDeposit;
  });
}
